<form
  class="form w-100 fv-plugins-bootstrap5 fv-plugins-framework"
  novalidate="novalidate"
  id="kt_login_password_reset_form"
>
  <div class="text-center mb-10">
    <h1 class="text-dark mb-3">Link Inválido</h1>
    <div class="text-gray-500 fw-bold fs-4">
      Esse link não é mais válido para alteração de senha
    </div>
  </div>

  <div class="d-grid mb-10">
    <a
      [routerLink]="['/auth/login']"
      id="kt_sign_in_submit"
      class="btn btn-primary"
    >
      <!--begin::Indicator label-->
      <span class="indicator-label">Ir para login</span>
      <!--end::Indicator label-->
    </a>
  </div>
</form>
